import React from 'react';
import classes from './SkeletonMenuCard.module.scss';
import Skeleton from '../Skeleton';

export default function SkeletonMenuCard() {
  return (
    <div className={classes.menuCard}>
      <div className={classes.menuCardImg}>
        <Skeleton borderRadius='0' width='100%' height='100%' isLight />
      </div>

      <div className={classes.menuCardDescription}>
        <div className={classes.menuCardName}>
          <Skeleton borderRadius='5px' width='100%' height={20} isLight={false} />
        </div>
        <div className={classes.menuCardText}>
          <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
        </div>
        <div className={classes.menuCardText2}>
          <Skeleton borderRadius='5px' width='100%' height={15} isLight={false} />
        </div>
      </div>
    </div>
  );
}
